import {
  SET_DRIVE_LIST,
  SET_PENDING_DRIVE_LIST,
  SET_SELECTED_DRIVE_INFO,
} from 'modules/Drive/actions'
const initialState = {
  listOfDrives: {},
  pendingDrives: [],
  selectedDriveInfo: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DRIVE_LIST:
      return {
        ...state,
        listOfDrives: action.data,
      }
    case SET_PENDING_DRIVE_LIST:
      return {
        ...state,
        pendingDrives: action.data,
      }
    case SET_SELECTED_DRIVE_INFO:
      return {
        ...state,
        selectedDriveInfo: action.data,
      }
    default:
      return state
  }
}
